export const APP_VERSION = 'v2026.11.05.0300';
// Auto-updated or maintained version string for Arena UI & Cache busting
export const ARENA_VERSION = 'v5.0.377';
export const ARENA_BUILD_ID = 'build-20261104.0005';
